export default __webpack_public_path__ + "static/media/SEG-Education-Courses.8c4c5bfc.png";